export default __webpack_public_path__ + "static/media/linktree.7078d2b1.svg";